import React from "react";
import { ShimmerTable } from "react-shimmer-effects";

const TableShimmer = ({ row = 10, col = 7 }) => {
  return <ShimmerTable row={row} col={col} />;
};

export default TableShimmer;
